import logo from "../assets/images/andromeda.png";
import google from "../assets/images/gogle.png";
import LoginRight from "./LoginRight";
import { Link } from "react-router-dom";
import { useState } from "react";
import auth, { provider } from "../firebase";

const Loginpage = () => {
  const [userName, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const registerNewUser = (e) => {
    e.preventDefault();
    if (!userName && !email && !password)
      return alert("Please enter the values..");

    auth
      .createUserWithEmailAndPassword(email, password)
      .then((newUser) =>
        newUser.user.updateProfile({
          displayName: userName,
        })
      )
      .catch((error) => alert(error.message));
  };

  const signIngoogle = () => {
    auth.signInWithPopup(provider).catch((err) => alert(err.message));
  };

  return (
    <div className="h-screen">
      <div className="sm:flex sm:justify-between h-screen">
        <div className=" bg-gray-100 w-full h-screen">
          <div>
            {/* HEADER */}
            <div className="flex justify-center py-2 sm:w-3/5 sm:ml-auto sm:mr-auto sm:justify-start">
              <img src={logo} alt="" />
            </div>
          </div>

          <div className="sm:w-3/5 sm:ml-auto sm:mr-auto mt-14">
            <h1 className=" text-2xl sm:text-2xl font-extrabold text-gray-800 p-2 sm:p-0">
              Sign up
            </h1>
          </div>

          <div className="sm:w-3/5 sm:ml-auto shadow-lg sm:mr-auto sm:mt-4 border-2 border-blue-400 rounded-md cursor-pointer hover:border-blue-600 hover:bg-gray-100">
            <div
              className="flex justify-center items-center py-1"
              onClick={signIngoogle}
            >
              <img src={google} alt="" className="h-7" />
              <p className="text-lg ml-3 font-semibold text-blue-500">
                Sign in with Google
              </p>
            </div>
          </div>

          <div className="mt-3">
            <h1 className="text-center text-2xl font-semibold text-blue-500">
              or
            </h1>
          </div>

          <div className="sm:w-3/5 sm:ml-auto shadow-lg  px-2 py-2 sm:mr-auto">
            <div>
              <form className="flex flex-col">
                <label className="text-sm font-bold text-gray-400 mb-1">
                  Name
                </label>
                <input
                  type="text"
                  value={userName}
                  onChange={(e) => setUsername(e.target.value)}
                  className="px-2 py-2 border border-gray-400 focus:outline-none mb-3 focus:border focus:border-blue-500"
                />
                <label className="text-sm font-bold text-gray-400 mb-1">
                  E-mail address
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="px-2 py-2 border border-gray-400 focus:outline-none mb-3 focus:border focus:border-blue-500"
                />
                <label className="text-sm font-bold text-gray-400 mb-1">
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="px-2 py-2 border border-gray-400 focus:outline-none mb-3 focus:border focus:border-blue-500"
                />

                <div className="flex justify-center p-2 mb-3">
                  <button
                    onClick={registerNewUser}
                    className="bg-blue-600 text-white focus:outline-none hover:bg-blue-500 font-bold text-base w-full py-2"
                  >
                    Create Account
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="mt-2">
            <h1 className="text-center text-gray-500">
              Already have an account ?{" "}
              <Link to="/login">
                <span className="text-blue-500 font-bold text-lg cursor-pointer">
                  Login
                </span>
              </Link>
            </h1>
          </div>
        </div>

        <div className="bg-gradient-to-r from-gray-800 to-gray-900 h-screen sm:w-[2000px] md:w-[800px] lg:w-[2000px]">
          <LoginRight />
        </div>
      </div>
    </div>
  );
};

export default Loginpage;
